import React from "react";

import { ReactComponent as LogoHorizontal } from "../../assets/icons/logo_horizontal.svg";
import { ReactComponent as LogoVertical } from "../../assets/icons/logo_vertical.svg";
import { ReactComponent as Close } from "../../assets/icons/close.svg";
import { ReactComponent as Profile } from "../../assets/icons/profile.svg";
import { ReactComponent as Sandwich } from "../../assets/icons/sandwich.svg";
import { ReactComponent as Back } from "../../assets/icons/back.svg";
import { ReactComponent as ArrowDown } from "../../assets/icons/arrow_down.svg";
import { ReactComponent as Pass } from "../../assets/icons/pass.svg";
import { ReactComponent as Chevron } from "../../assets/icons/chevron.svg";
import { ReactComponent as Calendar } from "../../assets/icons/calendar.svg";

interface IconProps {
  name: string;
  className?: string;
}

const Icon: React.FunctionComponent<IconProps> = ({ name, ...props }) => {
  switch (name) {
    case "logo":
      return <LogoHorizontal {...props} />;
    case "logo-vertical":
      return <LogoVertical {...props} />;
    case "close":
      return <Close {...props} />;
    case "profile":
      return <Profile {...props} />;
    case "sandwich":
      return <Sandwich {...props} />;
    case "back":
      return <Back {...props} />;
    case "arrow-down":
      return <ArrowDown {...props} />;
    case "pass":
      return <Pass {...props} />;
    case "chevron":
      return <Chevron {...props} />;
    case "calendar":
      return <Calendar {...props} />;
    default:
      return null;
  }
};

export default Icon;
